<template>
    <v-sheet>
        <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">
            이력 노출 유무
            <span v-if="mode == 'form'" class="page-text--sm grey-6--text pl-8 font-weight-regular">마이스펙인증 이력을 해당 이력서에 포함시킬지 확인해주세요</span>
        </h5>
        <v-divider class="primary border-2" />
        <v-btn text large class="px-19 mt-12 mb-n12" @click="toggleAll"> <v-simple-checkbox :value="isSelectedAll" color="primary" @click="toggleAll" /> 전체선택 </v-btn>
        <v-sheet>
            <template v-for="item in applications">
                <micepec-record-item v-model="selected" v-bind="{ item, mode }" class="my-24" :key="item._id" @input="emit" />
            </template>
        </v-sheet>
    </v-sheet>
</template>

<script>
import api from "@/api";
import MicepecRecordItem from "@/components/client/application/micepec-records/micepec-record-item.vue";

export default {
    components: {
        MicepecRecordItem,
    },
    props: {
        value: { type: Array, default: () => [] }, // selected
        mode: { type: String, default: "form" },
    },
    data: () => ({
        selected: [],
        applications: [],
    }),
    computed: {
        isSelectedAll() {
            return !this.applications.map(({ _id }) => _id).some((_id) => !this.selected.includes(_id));
        },
    },
    mounted() {
        this.sync();
        this.init();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.selected = [...this.value];
        },
        emit() {
            this.$emit("input", this.selected);
        },
        toggleAll() {
            if (this.isSelectedAll) this.selected = [];
            else this.selected = this.applications.map(({ _id }) => _id);
            this.emit();
        },
        async init() {
            const { applications = [] } = await api.v1.person.recruitmentApplications.gets({ params: { isCertified: true } });
            this.applications = applications;
        },
    },
};
</script>
